import React, { createContext, useContext } from 'react'
import { ProfileSettingsPageLogicContract } from './ProfileSettingsPageLogicContract'

const ProfileSettingsPageLogicContext = createContext<ProfileSettingsPageLogicContract | null>(null)

export const useProfileSettingsPageBusinessLogic = (): ProfileSettingsPageLogicContract | null => {
  return useContext(ProfileSettingsPageLogicContext)
}

interface ComponentProps extends React.ComponentProps<any>, ProfileSettingsPageLogicContract {}

export const ProfileSettingsPageBusinessLogicProvider: React.FunctionComponent<ComponentProps> = (props: React.PropsWithChildren<ComponentProps>) => {
  const { children, ...rest } = props

  return <ProfileSettingsPageLogicContext.Provider value={rest}>{children}</ProfileSettingsPageLogicContext.Provider>
}
